import { useQuery } from "@tanstack/react-query";
import {
	getKPIShiftReportData,
	type GetKPIShiftReportParams,
} from "../repositories/KPIShiftReportRepository";

type UseKPIShiftReportDataParams = Omit<GetKPIShiftReportParams, "signal">;

export const useKPIShiftReportData = ({
	start,
	end,
	crew = null,
}: UseKPIShiftReportDataParams) => {
	return useQuery({
		queryKey: ["kpiShiftReportData", start, end, crew],
		queryFn: ({ signal }) =>
			getKPIShiftReportData({ start, end, crew, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
